import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-estatistico-consulta`

    return {
        index() {
            return repository.get(`${baseUrl}`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        getMunicipios(queryParms) {
            return repository.get(`${baseUrl}/municipio?${urlUtil.serialize(queryParms)}`)
        },
        getUnidades(queryParms) {
            return repository.get(`${baseUrl}/unidade?${urlUtil.serialize(queryParms)}`)
        },
        getInfraestruturas(queryParms) {
            return repository.get(`${baseUrl}/infraestrutura?${urlUtil.serialize(queryParms)}`)
        },
        getEspecialidades(queryParms) {
            return repository.get(`${baseUrl}/especialidade?${urlUtil.serialize(queryParms)}`)
        },
        getUsuarios(queryParms) {
            return repository.get(`${baseUrl}/usuario?${urlUtil.serialize(queryParms)}`)
        },
    }
}